import React from 'react'
import Nav1 from './nav1';
import Nav2 from './nav2';
import Nav3 from './nav3';
import './nav.css'
export default function Navbar() {
    return (<>
            <Nav1 />
            <Nav2/>
            <Nav3/>
    </>)
}
